/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Box, useTheme, useMediaQuery, Button, Typography, Modal, FormHelperText, IconButton } from "@mui/material";
import "@styles/stylesRegistro.css";
import { PhoneCodeInput } from "@components/PhoneCodeInput";
import { CustomTextCiecBuro } from "@components/CustomTextCiecBuro";
// import { BuroValidatorRequest } from "@api/sat_apis_new/satApsi";
import { setModalErrorVisible } from "@store/slices/appSlice";
import { RootState, useAppDispatch } from "@store/store";
import { useSelector } from "react-redux";
import { ApiError } from "@interfaces/response";
import * as Sentry from "@sentry/react";
import CloseIcon from "@mui/icons-material/Close";
import { setCurretStepSecondGuarantee, setSecondGuaranteeCheckSatBureau } from "@store/slices/segundoAvalSlice";
// import { useLazyGetColonyByIdSecondGuaranteeQuery } from "@api/second_guarantee_api/catalogsSecondGuarantee";
import {
  useBuroValidatorSecondGuaranteeMutation,
  useLazyGetLoanApplicationByIdSecondGuaranteeQuery,
  // useBuroValidatorSecondGuaranteeMutation,
  usePatchUsuarioStatusSecondGuaranteeMutation,
  usePostValidateNextStageSecondGuaranteeMutation,
} from "@api/second_guarantee_api/secondGuaranteeApi";
import { useNextStepAndPatch } from "@hooks/useStatusConfigSecondGuarantee";
import { useLazyGetColonyByIdSecondGuaranteeQuery } from "@api/second_guarantee_api/catalogsSecondGuarantee";
import { BuroValidatorRequestPF } from "@api/sat_apis_new/satApsi";

const STATUS_LLENADO_SEGUNDO_AVAL = "CSLSA";
const STATUS_EN_REVISION = "CSREV";
interface ModalBuroNipProps {
  screenStatus: string;
  open: boolean;
  onClose: () => void;
}

const ModalBuroNipSecondGuarantee = (props: ModalBuroNipProps) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const shareholder = useSelector((state: RootState) => state.secondGuarante.guarantee);
  const { nextStatus } = useNextStepAndPatch(shareholder.status_config);

  const [confirmCode, setConfirmCode] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentStatusApplication, setCurrentStatusApplication] = useState(false);

  const [buroValidator] = useBuroValidatorSecondGuaranteeMutation();
  const [patchNextStatus] = usePatchUsuarioStatusSecondGuaranteeMutation();
  const [getColony] = useLazyGetColonyByIdSecondGuaranteeQuery();
  const [getLoadApplication] = useLazyGetLoanApplicationByIdSecondGuaranteeQuery();
  const [triggerPostNextStage] = usePostValidateNextStageSecondGuaranteeMutation();

  const continueToWaitingRoom = async () => {
    try {
      dispatch(setSecondGuaranteeCheckSatBureau({ check_sat_bureau: true }));

      await patchNextStatus({
        usuario: String(shareholder.user_id),
        body: {
          status_id: String(nextStatus?.status_id),
        },
      }).unwrap();

      if (currentStatusApplication) {
          await triggerPostNextStage({
            applicationId: String(shareholder?.loan_application_id),
            statusCode: STATUS_EN_REVISION,
            username: `TOFU - ${shareholder.email}`,
          }).unwrap();
      }

      dispatch(
        setCurretStepSecondGuarantee({
          code: String(nextStatus?.code),
          url: String(nextStatus?.url),
          sequence: Number(nextStatus?.sequence),
          status_id: String(nextStatus?.status_id),
        }),
      );

      navigate(String(nextStatus?.url));
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          component: "ConsultaBuroSegundoAval",
          values: {},
        },
      });
      dispatch(setModalErrorVisible({ open: true, error: error as ApiError }));
    }
  };

  const handleClickConfirm = async () => {
    try {
      setIsLoading(true);

      let colonyName;

      if (shareholder.address?.colony_id === -1) {
        colonyName = shareholder.address?.other_neighborhood || "";
      } else {
        const responseColony = await getColony({ colonyId: Number(shareholder.address?.colony_id) }).unwrap();
        colonyName = responseColony.name || "";
      }

      const first_name = shareholder.personalInfo.name.substring(0, 26).trim();
      const first_lastname = shareholder.personalInfo.first_lastname.substring(0, 26).trim();
      const second_lastname = shareholder.personalInfo.second_lastname.substring(0, 26).trim();
      const colony_name_trim = colonyName.substring(0, 26).trim();
      const exteriorNumber = shareholder.address?.no_ext ? shareholder.address?.no_ext.substring(0, 20).trim() : "";
      const interiorNumber = shareholder.address?.no_int ? shareholder.address?.no_int.substring(0, 20).trim() : "";

      const payload_buro: BuroValidatorRequestPF = {
        person_Type: "pf",
        data: {
          rfc: shareholder.personalInfo.rfc + shareholder.personalInfo.rfc_homoclave,
          curp: shareholder.personalInfo.curp,
          transaction_number: String(shareholder.loan_application_id),
          application_code: "",
          legal_name: first_name,
          first_name: first_name,
          second_name: "",
          father_last_name: first_lastname,
          mother_last_name: second_lastname === "" ? "" : second_lastname,
          reenter_NIP: true,
          authorization_label_response: true,
          loan_application_id: String(shareholder.loan_application_id),
          person_id: String(shareholder?.id),
          is_endorsement: true,
          address: {
            street: String(shareholder.address?.street),
            exteriorNumber: exteriorNumber,
            interiorNumber: interiorNumber,
            state: String(shareholder.address?.state_name),
            municipality: String(shareholder.address?.locality_name),
            locality: colony_name_trim,
            postalCode: String(shareholder.address?.postal_code),
          },
        },
      };

      await buroValidator(payload_buro).unwrap();
      await continueToWaitingRoom();
    } catch (error) {
      const apiError = error as ApiError;
      if (apiError.status === 409) {
        await continueToWaitingRoom();
      } else {
        Sentry.captureException(error, {
          extra: {
            component: "ConsultaBuro",
            values: {},
          },
        });
        dispatch(setModalErrorVisible({ open: true, error: apiError }));
      }
    } finally {
      setIsLoading(false);
    }
  };

   useEffect(() => {
      const fetchInitialData = async () => {
        try {
          setIsLoading(true);
         
  
          const responseApplication = await getLoadApplication(String(shareholder?.loan_application_id)).unwrap();
          const LLENANDO_AVAL_SEGUNDO_STATUS = responseApplication.status_catalog?.code === STATUS_LLENADO_SEGUNDO_AVAL;
          setCurrentStatusApplication(LLENANDO_AVAL_SEGUNDO_STATUS);
  
        } catch (error) {
          const api_error = error as ApiError;
          console.error("Error al obtener los datos iniciales", error);
          dispatch(setModalErrorVisible({ open: true, error: api_error }));
        } finally {
          setIsLoading(false);
        }
      };
  
      fetchInitialData();
    }, []);
  

  return (
    <Modal open={props.open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: "center",
          width: "70%",
          maxWidth: "400px",
          outline: "none",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={props.onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography fontWeight={"600"} gutterBottom color={theme?.palette?.primary?.dark}>
          Consulta a Buró de crédito
        </Typography>

        <Typography
          variant={isMobileOrTablet ? "body2" : "body1"}
          sx={{ mt: 2, mb: 2 }}
          color={theme?.palette?.primary?.dark}
        >
          <CustomTextCiecBuro type="nipBuroConfirm" />
        </Typography>

        <Typography
          variant={isMobileOrTablet ? "body2" : "body1"}
          sx={{ mt: 2, mb: 2 }}
          color={theme?.palette?.primary?.dark}
        >
          Confirma tu Código
        </Typography>

        <PhoneCodeInput
          name="code_confirm"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setConfirmCode(event.target.value);
          }}
          disabled={isLoading}
        />

        {confirmCode.length === 4 && confirmCode !== shareholder.buroNip.code && (
          <FormHelperText sx={{ mt: 1 }}>
            El código ingresado no es correcto. Por favor verifica el código y vuelve a intentarlo.
          </FormHelperText>
        )}

        <Button
          variant="default"
          color="primary"
          sx={{ mt: 2 }}
          onClick={handleClickConfirm}
          disabled={confirmCode !== shareholder.buroNip.code || isLoading}
        >
          Confirmar
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalBuroNipSecondGuarantee;
